/**
 * Compress an image URL or dataURL into a smaller JPEG dataURL.
 *
 * Shared by quotePdfGenerator.js and cciQuotePdfGenerator.js, which each
 * carried an identical private copy. Resolves to the original source if the
 * image fails to load, so a broken logo degrades to a missing image rather
 * than a rejected PDF.
 */
export const compressImage = (imgSrc, maxWidth = 800, quality = 0.7) => {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      let { width, height } = img;

      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;

      // Fill background with white so a transparent PNG does not turn black in JPEG
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, width, height);

      ctx.drawImage(img, 0, 0, width, height);

      resolve(canvas.toDataURL('image/jpeg', quality));
    };

    img.onerror = (err) => {
      console.error('compressImage error:', err);
      resolve(imgSrc); // fallback to original if something breaks
    };

    img.src = imgSrc;
  });
};

export default compressImage;
